import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addStep, allSteps, removeLayerConfig, changeStepOrder, duplicateStep } from '../../../../../../redux/stepsSlice';
import { getActiveStep, removeActiveLayer, setActiveStep } from '../../../../../../redux/toolsSlice';

// Left steps outline — reorder (move up/down), duplicate, add, and jump between
// steps. Same dispatches as the legacy StepSidebar, restyled to the mockup.
const StepsOutline = () => {
  const dispatch = useDispatch();
  const steps = useSelector((state) => allSteps(state));
  const activeStep = useSelector((state) => getActiveStep(state));
  const materialType = window?.location?.pathname?.split('/')?.[2] || 'paths';

  useEffect(() => {
    if (steps && steps.length > 0 && !activeStep?.id) {
      dispatch(setActiveStep(steps[0]));
    }
  }, []);

  const selectStep = (step) => {
    dispatch(setActiveStep(step));
    dispatch(removeActiveLayer());
    dispatch(removeLayerConfig());
  };

  const addNewStep = () => dispatch(addStep({ material_type: materialType }));

  const move = (e, fromIndex, toIndex) => {
    e.stopPropagation();
    if (toIndex < 0 || toIndex > steps.length - 1) return;
    dispatch(changeStepOrder({ fromIndex, toIndex }));
  };

  const duplicate = (e, step) => {
    e.stopPropagation();
    dispatch(duplicateStep(step.id));
  };

  const hasRule = (step) => step.display_rule && Array.isArray(step.display_rule.conditions)
    && step.display_rule.conditions.some((c) => c && c.attribute);

  return (
    <div className="un-pe-steps">
      <div className="un-pe-steps__h">Steps</div>
      <p className="un-pe-steps__hint">Reorder, add, and jump between steps.</p>
      {(steps || []).map((step, index) => (
        <div
          key={step.id}
          className={`un-pe-snav${step.id === activeStep?.id ? ' is-active' : ''}`}
          onClick={() => selectStep(step)}
        >
          <span className="un-pe-snav__n">{index + 1}</span>
          <div className="un-pe-snav__t">
            {step.title || step.name || `Step ${index + 1}`}
            {step.name && step.name !== step.title && <small>{step.name}</small>}
          </div>
          {hasRule(step) && <span className="un-pe-snav__rule">Rule</span>}
          <span className="un-pe-snav__ctl">
            <button
              type="button"
              aria-label="Move step up"
              title="Move up"
              disabled={index === 0}
              onClick={(e) => move(e, index, index - 1)}
            >
              <svg width="13" height="13" viewBox="0 0 20 20" fill="none"><path d="M5 12l5-5 5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </button>
            <button
              type="button"
              aria-label="Move step down"
              title="Move down"
              disabled={index === steps.length - 1}
              onClick={(e) => move(e, index, index + 1)}
            >
              <svg width="13" height="13" viewBox="0 0 20 20" fill="none"><path d="M5 8l5 5 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </button>
            <button type="button" aria-label="Duplicate step" title="Duplicate" onClick={(e) => duplicate(e, step)}>
              <svg width="13" height="13" viewBox="0 0 20 20" fill="none"><rect x="7" y="7" width="9" height="9" rx="2" stroke="currentColor" strokeWidth="1.5" /><path d="M4 13V5a1 1 0 0 1 1-1h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
            </button>
          </span>
        </div>
      ))}
      <button type="button" className="un-pe-addstep" onClick={addNewStep}>&#65291; Add step</button>
    </div>
  );
};

export default StepsOutline;
